define ([
	"jquery",
	"pubsub",
	"wcs.alert",
	'promise!wcs.zmetrics',
	"datalayer.wcs.mini-list",
	"coremetrics.wcs.mini-list",
	"promise!wcs.lang-msg",
], function ($, pubsub, alerts){

	var isTouchStarted 	= false,
		isTouchMoved 	= false,
		isLoading 		= false,
		originTouchPosY = 0,
		originListTop 	= 0,
		miniCartLocation = WCS_CONFIG.get('global::miniCartLocation'),
		$isCMSTopNav = ($('.topnav-header').length > 0),
		isTopMiniCart = ($isCMSTopNav || miniCartLocation === 'top');

	function addMiniListLoadingIndicator(settings) {

		if (isTopMiniCart) {
			alerts.showLoadingNotification('p');
		} else if (miniCartLocation ==='right'){
			alerts.showLoadingNotificationByPosition('l', '.global-cart-wishlist-panels-js');
		}
	}

	function removeMiniListLoadingIndicator(settings) {
		if (isTopMiniCart) {
			alerts.hideLoadingNotification();
		} else if (miniCartLocation ==='right'){
			alerts.hideLoadingNotificationByPosition('.global-cart-wishlist-panels-js');
		}
	}

	function renderMiniListItems (ajaxURL, params, settings, msg){
		addMiniListLoadingIndicator(settings);
		//If Ajax request is still loading, return
		if (isLoading) {
			return;
		}

		isLoading = true;

		return $.ajax({
			url: ajaxURL,
			dataType: 'html',
			data: params
		}).done(function(data){
			if (isTopMiniCart) {
				renderMiniListCartContent (data, settings, msg);
			} else {
				renderMiniListCartContent (data, settings);
			}
		}).always(function(data) {
			removeMiniListLoadingIndicator(settings);
			//Set isLoading back to false
			isLoading = false;
		});
	}

	function miniListActions(event){
		var $target 	= $(event.target),
			$contents 	= null;

		if ($target.data ('action') === 'delete' || $target.data ('action') === 'add to cart'){
			event.preventDefault ();
			var $container = $target.parents ('.cart-list'),
				settings = {'title': $container.find ('.page-title').text (), 'page': $container.data ('tabcontent'), 'container': $container},
				msg = ($target.data ('action') === 'add to cart') ? LANG_MSG["DEFAULT_MINICART.MSG.movedToShoppingCart"] : undefined;

			var $product = $target.parents(".cart-item-js").find(".cart-item-row");
			var attributeStr = "";
			$product.find(".item-attr-js.defining").each(function(){
				attributeStr += (attributeStr.length > 0 ? " / " : "") + $(this).text();
			});
			var seoCategory = $product.find(".product-info-js").data("seoCategory");
			var isQuickView =  false;
			var categoryId = (isQuickView ? $(".product-listing-js").data("categoryIdentifier") : '');
			var bundlePartNumber = $product.find(".product-info-js").data("bundlePartnumber");
			var childPartNumber = $product.find(".product-info-js").data("itemPartnumber");
			var masterCategoryId = $product.find(".product-info-js").data("masterCategory");
			var parentProductId = $product.find(".product-info-js").data("parentProductId");
			var childProductId = $product.find(".product-info-js").data("childProductId");
			var productId = $product.find(".product-info-js").data("partNumber");
			var styleCode = $product.find(".product-info-js").data("styleCode");
			var colorCode = $product.find(".item-attr-info-js").data("colorCode");
			var colorDescription = $product.find(".item-attr-info-js").data("colorDescription");
			var size = $product.find(".item-attr-info-js").data("size");
			var unitPrice = $product.find(".item-price-js").data("unitPrice");
			var parameters = {
					currency: WCS_CONFIG.get("global::currencyCode"),
					'productName': $product.find(".item-name-js").text().replace(/^\s+|\s+$/gm,''),
					'productId': productId ? productId : '',
					'unitPrice': unitPrice ? unitPrice : '',
					'definingAttributes': $.trim(attributeStr),
					'quantity': $product.find(".item-qty-js").data("qty"),
					'categoryId': categoryId ? categoryId : '',
					'masterCategoryId': masterCategoryId ? masterCategoryId : '',
					'childPartNumber': childPartNumber ? childPartNumber : '',
					'parentProductId': parentProductId ? parentProductId : '',
					'childProductId': childProductId ? childProductId : '',
					'bundlePartNumber': bundlePartNumber ? bundlePartNumber : '',
					'seoCategory': seoCategory ? seoCategory : '',
					'isQuickView': isQuickView,
					'isSearch': (isQuickView && categoryId === 'search'),
					'styleCode': styleCode ? styleCode : '',
					'colorCode': colorCode ? colorCode : '',
					'colorDescription': colorDescription ? colorDescription : '',
					'size': size ? size : ''
				};

			callAction ($target.attr ('href'), settings, msg, $target.data ('action'), parameters);
			if($target.data ('action') === 'add to cart'){
				$.pubsub('publish', 'vfdp.wcs.mini_list.add_to_cart_clicked');
				zm.trackAddedItem(parameters);
			}
		}
	}

	function initMiniListActions(){
		// Adding listeners only to Remove Item and Add to Cart
		var $element = '.mini-cart-action-remove-item-js, .mini-cart-action-add-to-cart-js';

		$(document).on('click', $element, function(event) {
			miniListActions(event);
		});
	}

	function callAction (ajaxURL, settings, msg, action, parameters){
		action = action || 'remove';

		addMiniListLoadingIndicator(settings);

		$.ajax({
			url: ajaxURL,
			type: 'POST',
			dataType: 'html',
			success: function(response){

				if(settings.page === "wishlist") {
					renderMiniListCartContent (response, settings, msg, action);
					$.pubsub('publish','WISHLIST_UPDATED.remove', data = {
						product : [{
							bundleId: parameters.bundlePartNumber,
							itemId: parameters.childPartNumber,
							name: parameters.productName,
							productId: parameters.productId
						}]
					});

					if(action === 'add to cart') {
						if($('.shopcart-js').length > 0) {
							window.location.href=$('.btn-shoppingbag-js').attr('href');
						}

						if(orderId) {
							$.pubsub('publish', 'vfdp.wcs.mini_list.add_to_cart_succeeded', parameters);
						}
					}
				} else if(settings.page === "shopcart" && action === "delete" && orderId) {
					if (miniCartLocation ==='right') {
						renderMiniListCartContent (response, settings, msg, action);
					}
				}


				var shopCartAction = (action == 'delete' || action == 'remove') ? 'remove' : 'add';
				$.pubsub('publish', 'SHOPCART_UPDATED.'+shopCartAction, {
					product: [{
						bundleId: parameters.bundlePartNumber,
						itemId: parameters.childPartNumber,
						name: parameters.productName,
						productId: parameters.productId
					}],
					rewardEligibility: {
						orderId: orderId,
						rewardOptionEligible: rewardOptionEligible,
						rewardsAdded: rewardsAdded
					},

					action: action
				});
			}
		}).always(function(response){
			removeMiniListLoadingIndicator(settings);
		});
	}

	function renderMiniListCartContent(data, settings, msg, action){
		settings.container.html (data);

		if(action === 'add to cart'){
			settings.container.find('.ajax-messaging').html('<p class="message success">'+msg+'</p>');
		}

		setupCarousel(settings);
		$.pubsub('publish', 'MINICART_CONTENT_RENDER_COMPLETE', msg);
	}

	function renderItemAttributes (attributes){
		var attributesHTML = "";
		$.each (attributes, function (){
			var $attribute = $(this)[0];
			attributesHTML += '<p>'+ $attribute.name + ': '+ $attribute.value +'</p>';
		});
		return attributesHTML;
	}
	function renderQuantityOptions (qty, threshold){
		var options = '<form class="cart-item-col" novalidate="novalidate">'+
						'<select class="small" id="item-qty">';
		for (var i = 1; i < (threshold + 1); i++){
			if (qty === i){
				options += '<option selected="selected" value="'+i+'">'+i+'</options>';
			}
			else{
				options += '<option value="'+i+'">'+i+'</options>';
			}
		}
		options += 	'</select></form>';
		return options;
	}

	// calculate the available height for mini-cart items
	function calculateItemHeight(settings){
		var containerHeight = settings.container.height(),
			 titleHeight = 0,

			 $contentHead = settings.container.find('.content-head'),
			 contentHeadMarginTop = parseInt($contentHead.css('margin-top'), 10),
			 contentHeadMarginBottom = parseInt($contentHead.css('margin-bottom'), 10),

			 $sectionTitle = $contentHead.find('.section-title'),
			 sectionTitleMarginTop = parseInt($sectionTitle.css('margin-top'), 10),
			 sectionTitleHeight = $sectionTitle.outerHeight(false),

			 $pageTitle = $contentHead.find('.page-title'),
			 pageTitleMarginTop = parseInt($pageTitle.css('margin-top'), 10),
			 pageTitleHeight = $pageTitle.outerHeight(false),

			 cartActionsHeight = settings.container.find('.cart-actions, .wishlist-actions').outerHeight(true),

			 espotMarginTop = 0,
			 espotHeight = 0,
			 espotMarginBottom = 0,

			 $wavedLineSep = settings.container.find('.waved-line-sep'),
			 wavedLineSepMarginTop = parseInt($wavedLineSep.css('margin-top'), 10),
			 wavedLineSepHeight = $wavedLineSep.outerHeight(true);

		var marginTop = Math.max(contentHeadMarginTop, sectionTitleMarginTop);
		titleHeight = marginTop + sectionTitleHeight + pageTitleMarginTop + pageTitleHeight + contentHeadMarginBottom;
		titleHeight = Math.max(marginTop + contentHeadMarginBottom, titleHeight);

		var $freeShippingPromo = settings.container.find('.free-shipping-promo'),
			 $miniCartPromoHeader = settings.container.find('.mini-cart-promo-header');
		if($freeShippingPromo.length > 0) {
			espotMarginTop = parseInt($freeShippingPromo.css('margin-top'), 10);
			espotHeight = $freeShippingPromo.outerHeight(false);
			espotMarginBottom = parseInt($freeShippingPromo.css('margin-bottom'), 10);
		} else if($miniCartPromoHeader.length > 0) {
			$miniCartPromoHeader.each(function() {
				var $this = $(this);
				if($this.parents('.cart-item-container-js').length > 0) return false;
				else {
					espotMarginTop = parseInt($this.css('margin-top'), 10);
					espotHeight = parseInt($this.parents('.espot-container').outerHeight(false));
					espotMarginBottom = parseInt($this.parents('.espot-container').find('p').css('margin-bottom'), 10);
				}
			});
		}
		espotHeight = espotMarginTop + espotHeight + espotMarginBottom;

		return containerHeight - titleHeight - cartActionsHeight - wavedLineSepHeight - espotHeight + Math.min(espotMarginBottom, wavedLineSepMarginTop);
	}

	function initCarousel(settings){
		var slideHeight = settings.container.find('.cart-item-slide-js').outerHeight(true),
			miniListItems = document.querySelectorAll('.cart-item-js'),
			slideContainerHeight = calculateItemHeight(settings);

		// top location property for mini cart
		if (isTopMiniCart) {
			var slideCount = settings.container.find('.cart-item-js').length,
				customHeader = $('#miniCartCustomHead');

			//Check each item and push height into array
			var slideContainerHeights = Array.prototype.map.call(miniListItems,
				function(item){
					return item.offsetHeight;
				});

			// Set default slideHeight to largest height of items in minilist
			slideHeight = Math.max.apply(Math, slideContainerHeights);

			slideContainerHeight = slideHeight * Math.min(2, slideCount);
			if (customHeader.length > 0) {
				slideContainerHeight += customHeader.outerHeight(true);
			}
			settings.container.find('.cart-item-container-js').css({'height': slideContainerHeight + 'px'});

			if(slideCount > 2) {
				if(settings.container.find('.cart-item-nav').hasClass('hide')){
					settings.container.find('.cart-item-nav').removeClass('hide');
				}
			} else {
				if(!settings.container.find('.cart-item-nav').hasClass('hide')){
					settings.container.find('.cart-item-nav').addClass('hide');
					settings.container.find('.cart-item-slide-js').css('top', '');
				}
			}

		} else {
			// right location property for mini cart
			if(slideContainerHeight >= slideHeight){
				//enough space to show everything
				settings.container.find('.cart-item-container-js').css('height', slideContainerHeight + 'px');

				if(!settings.container.find('.cart-item-nav').hasClass('hide')){
					settings.container.find('.cart-item-nav').addClass('hide');
					settings.container.find('.cart-item-slide-js').css('top', '');
				}
			}
			else{
				//show carousel control
				settings.container.find('.cart-item-container-js').css('height', (slideContainerHeight - 70) + 'px');
				if(settings.container.find('.cart-item-nav').hasClass('hide')){
					settings.container.find('.cart-item-nav').removeClass('hide');
				}
			}
		}
	}

	function setupCarousel(settings){
		initCarousel(settings);

		settings.container.find('.cart-item-nav.prev').on('click', function(){
			if(!$(this).hasClass('ready')) return false;
			if($(this).hasClass('disabled')) return false;

			var top = getSlideTop($(this).closest('.cart-list').find('.cart-item-slide-js')),
				cartItemHeight = $(this).closest('.cart-list').find('.cart-item').outerHeight(true);

			$(this).removeClass('ready');
			$(this).closest('.cart-list').find('.cart-item-nav.next').removeClass('disabled');
			$(this).closest('.cart-list').find('.cart-item-slide-js').animate({
				top: "+=" + Math.min(-top, cartItemHeight)
			}, 300, function(){
				$(this).closest('.cart-list').find('.cart-item-nav.prev').addClass('ready');

				var top = getSlideTop($(this).closest('.cart-list').find('.cart-item-slide-js'));

				if(top >= 0) {
					$(this).closest('.cart-list').find('.cart-item-nav.prev').addClass('disabled');
				}
			});
		}).on('keydown', function(event){
			if(event.keyCode === 32 || event.keyCode===13) {
				event.preventDefault();
				$(this).click();
			} else {
				return;
			}
		});

		settings.container.find('.cart-item-nav.next').on('click', function(){
			if(!$(this).hasClass('ready')) return false;

			var slideHeight = settings.container.find('.cart-item-slide-js').outerHeight(false),
				slideContainerHeight = settings.container.find('.cart-item-container-js').outerHeight(true),
				top = getSlideTop($(this).closest('.cart-list').find('.cart-item-slide-js')),
				cartItemHeight = $(this).closest('.cart-list').find('.cart-item-js').outerHeight(true),
				animateTop;

			if(slideHeight + parseInt(top) <= slideContainerHeight){
				return false;
			}

			newTop = slideHeight + parseInt(top) - cartItemHeight;
			animateTop = (newTop <= slideContainerHeight) ? cartItemHeight - (slideContainerHeight - newTop) : cartItemHeight;

			$(this).removeClass('ready');
			$(this).closest('.cart-list').find('.cart-item-nav.prev').removeClass('disabled');
			$(this).closest('.cart-list').find('.cart-item-slide-js').animate({
				top: "-=" + animateTop
			}, 300, function(){
				$(this).closest('.cart-list').find('.cart-item-nav.next').addClass('ready');

				var slideHeight = settings.container.find('.cart-item-slide-js').outerHeight(true),
				slideContainerHeight = settings.container.find('.cart-item-container-js').outerHeight(true);

				var top = getSlideTop($(this).closest('.cart-list').find('.cart-item-slide-js'));

				if(slideHeight + parseInt(top) <= slideContainerHeight) {
					$(this).closest('.cart-list').find('.cart-item-nav.next').addClass('disabled');
				}
			});
		}).on('keydown', function(event){
			if(event.keyCode === 32 || event.keyCode===13) {
				event.preventDefault();
				$(this).click();
			} else {
				return;
			}
		});

		settings.container.find(".cart-item-container-js").on({
			"wheel": miniCartScrollHandler, // binding mousewheel events for firefox
			"touchstart": function(e) {
				var $slide = $(this).closest('.cart-list').find('.cart-item-slide-js');
				$slide.stop();

				isTouchStarted = true;
				originTouchPosY = e.originalEvent.touches[0].clientY;
				originListTop = getSlideTop($slide);
			},
			"touchmove": function(e) {
				isTouchMoved = true;
				e.preventDefault();

				var $slide = $(this).closest('.cart-list').find('.cart-item-slide-js'),
					$slideContainer = $(this).closest('.cart-list').find('.cart-item-container-js'),
					slideHeight = $slide.outerHeight(true),
					slideContainerHeight = $slideContainer.outerHeight(true),
					delta = e.originalEvent.touches[0].clientY - originTouchPosY, // how far the swipe goes
					newListTop = originListTop + delta, // new top position for cart slide
					listTopBottom = Math.min(0, slideContainerHeight - slideHeight), // top position for cart slide when scrolled to bottom
					$prevButton = settings.container.find('.cart-item-nav.prev'),
					$nextButton = settings.container.find('.cart-item-nav.next');

				if(newListTop < 0 && newListTop > listTopBottom) {
					$slide.css('top', newListTop + 'px');
					if($prevButton.hasClass('disabled')) $prevButton.removeClass('disabled');
					if($nextButton.hasClass('disabled')) $nextButton.removeClass('disabled');
				} else if(newListTop >= 0) {
					$slide.css('top', (newListTop / 2) + 'px');
					if(!$prevButton.hasClass('disabled')) $prevButton.addClass('disabled');
				} else if(newListTop <= listTopBottom) {
					$slide.css('top', (newListTop / 2 + listTopBottom / 2) + 'px');
					if(!$nextButton.hasClass('disabled')) $nextButton.addClass('disabled');
				}
			},
			"touchend": function(e) {
				if(isTouchStarted && isTouchMoved) {
					var $slide = $(this).closest('.cart-list').find('.cart-item-slide-js'),
						$slideContainer = $(this).closest('.cart-list').find('.cart-item-container-js'),
						slideHeight = $slide.outerHeight(true),
						slideContainerHeight = $slideContainer.outerHeight(true),
						listTopBottom = slideContainerHeight - slideHeight,
						top = getSlideTop($slide);

					if(top > 0 || slideContainerHeight - slideHeight > 0) {
						$slide.animate({top: '0px'}, 400);
					} else if(top < slideContainerHeight - slideHeight) {
						$slide.animate({top: listTopBottom + 'px'}, 400);
					}
				}
				isTouchStarted = false;
				isTouchMoved = false;
				originTouchPosY = e.originalEvent.changedTouches[0].clientY;
			}
		});


		settings.container.on({
			"touchmove": function(e) {
				e.preventDefault();
			}
		});

		// binding mousewheel events for IE & chrome
		$(document).on("mousewheel", miniCartScrollHandler);

		function getSlideTop($slide) {
			var top = $slide.css('top') || 'auto';
			if(top == 'auto') top = '0px';
			return parseFloat(top.replace(/[^-\d\.]/g, ''));
		}

		function miniCartScrollHandler(e) {
			var $this = $(e.target);

			if($this.hasClass("cart-item-container-js") || $this.parents(".cart-item-container-js").length > 0) {
				var wheelDelta = -e.originalEvent.deltaY,
					delta = Math.max(-1, Math.min(1, wheelDelta));

				if(delta < 0) { //scroll down
					if(!settings.container.find(".cart-item-nav.next").hasClass("hide") && !settings.container.find(".cart-item-nav.next").hasClass("disabled")) {
						settings.container.find(".cart-item-nav.next").trigger("click");
					}
				} else if(delta > 0) { //scroll up
					if(!settings.container.find(".cart-item-nav.prev").hasClass("hide") && !settings.container.find(".cart-item-nav.prev").hasClass("disabled")) {
						settings.container.find(".cart-item-nav.prev").trigger("click");
					}
				}
				return false;
			} else return true;
		}

		$(window).on('resize', function(){
			initCarousel(settings);

			var slideHeight = settings.container.find('.cart-item-slide-js').outerHeight(true),
				slideContainerHeight = calculateItemHeight(settings);

			var top = getSlideTop(settings.container.find('.cart-item-slide-js'));

			if(slideHeight + parseInt(top) < slideContainerHeight - 50){
				settings.container.find('.cart-item-nav.next').addClass('disabled');
			} else {
				settings.container.find('.cart-item-nav.next').removeClass('disabled');
			}
		});
	}

	initMiniListActions();

	return {
		renderMiniListItems : renderMiniListItems,
		initCarousel : initCarousel
	};
});